import CustomIcons from "../GlobalComponents/CustomIcons";
import React, { Component } from "react";
import settings from "../../settings";
import FetchResponses from "../../models/FetchResponses";
import Auth from "../../models/Auth";
import { Collapse } from "antd";
import { Link } from "react-router-dom/cjs/react-router-dom";
import ReactHtmlParser from "react-html-parser";

const Panel = Collapse.Panel;
class FAQHome extends Component {
  constructor(props) {
    super(props);
    this.state = {
        preguntaActiva: '',
        FAQ: []
    };
  }

  componentDidMount = () => {
    this.getQuestions()
  }


  componentDidUpdate(prevProps, prevState) {    
    if(prevProps.front_modules != this.props.front_modules){
      this.getQuestions()
    }
  }

  getQuestions = () => {
    let modules = []

    if(!this.props.front_modules.modules){
      return
    }

    this.props.front_modules.modules.forEach(element => {
      if (element.module_type === 'FAQ') {
        modules = [...modules, element]
      }
    })

    modules.sort(function (a, b) {
      return a.extra_properties.position - b.extra_properties.position
    })

    this.setState({
      FAQ: modules,
      modules,
    })
  }

  handleChangeSection(index) {
    if(index == this.state.preguntaActiva) {
        index = null
    }
    this.setState({preguntaActiva: index})
  }
  render() {
    const { FAQ, preguntaActiva } = this.state
    return (
      <div className="faqhome">
          <div className="faqhome-content">
            <h2 class="maintitle">Preguntas frecuentes</h2>
            <div className="faq-collapsible__container">
                {FAQ.slice(0, 3).map((pregunta) => {
                    return (
                        <div className="faq-collapsible__panel">
                            <div 
                                type="button" 
                                class="faq-collapsible__panel__button"
                                onClick={() => {this.handleChangeSection(pregunta.name)}}
                            >
                                
                                {<div className="faq-collapsible-tags">
                                    {pregunta.extra_properties && pregunta.extra_properties.tags && pregunta.extra_properties.tags.map((tag) => {
                                       return(<span  className="faq-collapsible-tag">{tag}</span>)
                                    })}
                                </div>}

                                <div className="faq-collapsible-title">
                                    {pregunta.title}
                                    <CustomIcons className='faq-collapsible-icon' icon={preguntaActiva == pregunta.name ? 'minusSign' : 'plusSign'} />
                                </div>

                                <div class={preguntaActiva == pregunta.name ? 'content active' : 'content'}>
                                    <div className="faq-content-divisor"></div>
                                    {ReactHtmlParser(pregunta.content)}
                                </div> 
                            </div>

                        </div>
                    )
                })}
            </div>
            <Link className='faq-more-questions' to='/faq'>
                Ver más preguntas frecuentes
                <CustomIcons icon='arrow' className='icon'/>
            </Link>
          </div>
      </div>
    );
  }
}

export default FAQHome;
